import { useNewCode } from '@calendly/feature-check-react';
import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Button } from '@calendly/ui/components/button';
import { FixedContainer } from '@calendly/ui/components/fixed-container';
import { Grid, GridItem } from '@calendly/ui/components/grid';
import { Loader } from '@calendly/ui/components/loader';
import { Sheet } from '@calendly/ui/components/sheet';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useState, forwardRef, useRef } from 'react';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import { Error } from './components/error';
const styledSheetCss = "s1a84ye7";
const StyledSheet = forwardRef((props, ref) => <Sheet ref={ref} {...props} className={classNames(styledSheetCss, props.className)} />);
const styledFixedContainerCss = "s1tte82g";
const StyledFixedContainer = forwardRef((props, ref) => <FixedContainer ref={ref} {...props} className={classNames(styledFixedContainerCss, props.className)} />);
const gridWrapperIsPhoneCss = "g4czil3";
const gridWrapperUseNewPaddingCss = "guc8eb5";
const gridWrapperCss = "g11n016t";
const GridWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    useNewPadding = false,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(gridWrapperCss, {
    [gridWrapperIsPhoneCss]: isPhone,
    [gridWrapperUseNewPaddingCss]: useNewPadding
  }, props.className)} />;
});
const footerCss = "fk8z21x";
const Footer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(footerCss, props.className)} />;
});
const actionsContainerIsPhoneCss = "a1t23cq0";
const actionsContainerCss = "a7jvh8u";
const ActionsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(actionsContainerCss, {
    [actionsContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const buttonTextWrapperIsPhoneCss = "b1mx23fe";
const buttonTextWrapperCss = "b1o0nb3g";
const ButtonTextWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(buttonTextWrapperCss, {
    [buttonTextWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const viewMoreButtonCss = "v15f01vh";
const ViewMoreButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(viewMoreButtonCss, props.className)} />);
const clearButtonIsPhoneCss = "c1ved8m8";
const clearButtonCss = "clilnd6";
const ClearButton = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <BareButton ref={ref} {...props} className={classNames(clearButtonCss, {
    [clearButtonIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const BaseFilterModal = ({
  isOpen,
  onClose,
  onApply,
  onClear,
  hasError,
  advancedFilters,
  isResultsLoading,
  resultCount,
  children,
  triggerRef
}) => {
  const isPhone = useDeviceType('isPhone');
  const filterModalRef = useRef(null);
  const [showMore, setShowMore] = useState(!!isPhone);
  const FilterComponent = isPhone ? StyledFixedContainer : StyledSheet;

  // Handle click outside, but exclude clicks on the trigger button.
  useOnClickOutside(filterModalRef, event => {
    if (!triggerRef?.current?.contains(event.target) && !isPhone) {
      onClose();
    }
  });
  const useSaFilterSettingsFlag = useNewCode('sa_filter_settings_mtg_pg', false)?.enabled;
  if (!isOpen) return null;
  return <FilterComponent ref={filterModalRef} aria-label={I18n.t('publisher.meetings.filter_modal.label')}>
      {hasError && <Error />}
      <GridWrapper useNewPadding={useSaFilterSettingsFlag}>
        <Grid spacingTop="8">
          {children}
          {!useSaFilterSettingsFlag && !showMore && <GridItem size="12">
                <ViewMoreButton onClick={() => setShowMore(true)}>
                  {I18n.t('publisher.meetings.filter_modal.expand')}
                </ViewMoreButton>
              </GridItem>}
          {!useSaFilterSettingsFlag && showMore && advancedFilters}
          {useSaFilterSettingsFlag && advancedFilters}
        </Grid>
      </GridWrapper>
      <Footer>
        {isResultsLoading ? <Loader size="small" /> : <BodyText color="muted">
              {I18n.t('publisher.meetings.filter_modal.results', {
          count: resultCount
        })}
            </BodyText>}
        <ActionsContainer>
          <ClearButton decoration="minimal" onClick={onClear}>
            {isPhone ? I18n.t('publisher.action.reset') : I18n.t('publisher.meetings.filter_modal.reset')}
          </ClearButton>
          <Button onClick={onClose} decoration="secondary-outline">
            <ButtonTextWrapper>
              {I18n.t('publisher.action.cancel')}
            </ButtonTextWrapper>
          </Button>
          <Button onClick={onApply}>
            <ButtonTextWrapper>
              {I18n.t('publisher.action.apply')}
            </ButtonTextWrapper>
          </Button>
        </ActionsContainer>
      </Footer>
    </FilterComponent>;
};

require("./base_filter_modal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./base_filter_modal.js");